// extracted by mini-css-extract-plugin
export default {"primaryPrice":"MwTOW","complementaryPrimaryPrice":"B5op3","secondaryPrice":"np5x1","gridPrice":"Z8aEX","isSalePrice":"BR6YF"};